import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { CommonToastService } from '@common2/services/toast.service';
import { NotificationService } from './notification.service';
@Injectable({ providedIn: 'root' })
export class EchoService {
    public echo: Echo<any>;
    private reconnectTries = 0;
    private maxReconnectAttempts = 5;
    private subscriptions: {
        type: 'user' | 'company';
        accountId?: number;
        companyId: number;
        events: { [eventName: string]: (data: any) => void };
        channelName: string;
    }[] = [];
    constructor(
        private http: HttpClient,
        private toastService: CommonToastService,
        private notificationService: NotificationService
    ) {
        (window as any).Pusher = Pusher;
        const token = sessionStorage.getItem(environment.tokenSessionName);
        /* const pusher = new Pusher('ovvyit7lsoaoawpdimcy', {
            cluster: 'mt1',
            wsHost: 'websocketserver-e4bb0cb0f8c3.deltablue.io',
            wsPort: 6501,
            wssPort: 6501,
            forceTLS: false,
            disableStats: true,
            enabledTransports: ['ws'],
        }); 
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.key}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.cluster}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.wsHost}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.wsPort}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.wssPort}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.forceTLS}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.disableStats}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.enabledTransports}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.WebSocket.encrypted}`
        );
        console.log(
            `[EchoService] Inicializando Echo ${environment.envVar.API_BROADCAST}`
        );*/
        this.echo = new Echo({
            broadcaster: 'pusher',
            /*enviroment/variable*/
            key: environment.WebSocket.key,
            cluster: environment.WebSocket.cluster,
            wsHost: environment.WebSocket.wsHost,
            wsPort: environment.WebSocket.wsPort,
            wssPort: environment.WebSocket.wssPort,
            forceTLS: environment.WebSocket.forceTLS,
            disableStats: environment.WebSocket.disableStats,
            enabledTransports: environment.WebSocket.enabledTransports,
            encrypted: ['ws'],
            authorizer: (channel, options) => {
                return {
                    authorize: (socketId, callback) => {
                        /*
                        console.log(
                            '[EchoService] Ejecutando authorizer personalizado'
                        );
                        console.log(
                            '[EchoService] Token usado para auth:',
                            token
                        );
                        console.log(
                            `[EchoService] endpoint:${environment.envVar.API_BROADCAST}`
                        );*/
                        fetch(
                            `${environment.envVar.API_BROADCAST}/api/broadcasting/auth`,
                            {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify({
                                    socket_id: socketId,
                                    channel_name: channel.name,
                                }),
                            }
                        )
                            .then((response) => {
                                if (response.ok) {
                                    return response.json().then((data) => {
                                        console.log(
                                            '[EchoService] Respuesta OK del auth:',
                                            data
                                        ); // 👈 aquí logueas
                                        return data;
                                    });
                                }

                                return response.json().then((errBody) => {
                                    console.error(
                                        '[EchoService] Respuesta de error del auth:',
                                        errBody
                                    ); // 👈 aquí también logueas
                                    throw {
                                        status: response.status,
                                        body: errBody,
                                    };
                                });
                            })
                            .then((data) => callback(false, data))
                            .catch((error) => {
                                console.error(
                                    `[EchoService] Error autorizando canal ${channel.name}`
                                );
                                console.error('→ Status:', error.status);
                                console.error('→ Body:', error.body);
                                callback(true, error);
                            });
                        /* .then((response) => {
                                if (response.ok) return response.json();
                                throw new Error('Authorization failed');
                            })
                            .then((data) => callback(false, data))
                            .catch((error) => callback(true, error)); */
                    },
                };
            },
        });

        setTimeout(() => {
            this.listenToConnectionEvents();
        }, 500);
    }

    /**
     * Suscribirse a un canal privado de usuario con múltiples eventos
     */
    subscribePrivateUserChannel(
        accountId: number,
        companyId: number,
        events: { [eventName: string]: (data: any) => void }
    ) {
        const channelName = `channel.user.${accountId}.company.${companyId}`;

        const channelPublicName = `privateUserChannel`;
        //console.log('[EchoService] Subscribing to', channelName);
        //console.log('[EchoService] Subscribing to', channelPublicName);
        const channel = this.echo.private(channelName);

        this.bindSubscriptionEvents(channel, channelName, channelPublicName);

        for (const event in events) {
            channel.listen(`.${event}`, events[event]);
        }
        this.subscriptions.push({
            type: 'user',
            accountId,
            companyId,
            events,
            channelName,
        });
    }

    /**
     * Suscribirse a un canal privado de empresa con múltiples eventos
     */
    subscribePrivateCompanyChannel(
        companyId: number,
        events: { [eventName: string]: (data: any) => void }
    ) {
        const channelName = `channel.company.${companyId}`;

        const channelPublicName = `privateCompanyChannel`;
        //console.log('[EchoService] Subscribing to', channelName);
        //console.log('[EchoService] Subscribing to', channelPublicName);
        const channel = this.echo.private(channelName);

        this.bindSubscriptionEvents(channel, channelName, channelPublicName);

        for (const event in events) {
            channel.listen(`.${event}`, events[event]);
        }
        this.subscriptions.push({
            type: 'company',
            companyId,
            events,
            channelName,
        });
    }

    /**
     * Abandonar un canal
     */
    leave(channelName: string, channelPublicName: string) {
        //console.log('[EchoService] Abandonando', channelPublicName);
        this.echo.leave(channelName);
    }

    /**
     * Cierra todas las conexiones activas
     */
    disconnect() {
        this.echo.disconnect();
        //console.log('[EchoService] Desconectado manualmente de Echo');
    }

    /**
     * Escucha eventos de conexión/desconexión para reconectar
     */
    private listenToConnectionEvents() {
        const connector: any = this.echo.connector;
        //console.log('listenToConnectionEvents', connector);
        if (connector.pusher) {
           // console.log('Para acá entró');
            const pusher = connector.pusher as Pusher;
            pusher.connection.bind('connected', () => {
                this.reconnectTries = 0;
                //console.log('[EchoService] Conectado a WebSocket');
                /*const socketId =
                    this.echo.connector.pusher.connection.socket_id;
                console.log('[EchoService] socket_id:', socketId);*/
                //this.resubscribeAll();
            });
            pusher.connection.bind('disconnected', () => {
                console.warn('[EchoService] Desconectado de WebSocket');
            });
            pusher.connection.bind('error', (err: any) => {
                console.error('[EchoService] Error de conexión', err);
            });
            pusher.connection.bind('unavailable', () => {
                if (this.reconnectTries < this.maxReconnectAttempts) {
                    this.reconnectTries++;
                   /* console.log(
                        `[EchoService] Reintentando conexión (${this.reconnectTries}/${this.maxReconnectAttempts})...`
                    );*/
                } else {
                    console.error(
                        '[EchoService] Se alcanzó el límite de reintentos'
                    );
                }
            });
        } else {
            console.warn(
                '[EchoService] No se pudo acceder a connector.pusher. ¿Se pasó client: Pusher en la configuración?'
            );
        }
    }

    handleNotification(data: any): void {
        const type = data?.type;
        const message = data?.message || 'Tienes una nueva notificación';

        // Mostrar el toast
        this.toastService.onInfo(message);
        // Realizar acciones adicionales según el tipo de notificación
        this.notificationService.pushNotification({
            id: data.id,
            title: data.title || 'Nueva notificación',
            message: data.message,
            type: data.type,
            extra: data.extra,
            read: data.read,
            createdAt: new Date(data.created_at),
        });
        this.notificationService.newNotification();
    }
    private bindSubscriptionEvents(
        channel: any,
        channelName: string,
        channelPublicName: string
    ) {
        const subscription = channel.subscription;

        subscription?.bind('pusher:subscription_succeeded', () => {
            // console.log('[EchoService] Subscribed to', channelName);
            //console.log('[EchoService] Subscribed to', channelPublicName);
        });

        subscription?.bind('pusher:subscription_error', (status: any) => {
            console.error(
                '[EchoService] Subscription error on',
                channelName,
                'Status:',
                status
            );
        });

        subscription?.bind('pusher:subscription_failed', () => {
            console.error('[EchoService] Subscription failed on', channelName);
        });
    }
    private resubscribeAll() {
        this.subscriptions.forEach((sub) => {
            // 🔄 Abandonar canal antes de volver a suscribirse
            this.echo.leave(sub.channelName);
            if (sub.type === 'user') {
                this.subscribePrivateUserChannel(
                    sub.accountId!,
                    sub.companyId,
                    sub.events
                );
            } else {
                this.subscribePrivateCompanyChannel(sub.companyId, sub.events);
            }
        });
    }
}
